import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-be965a96"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["width", "height"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20ZM30.0601 16.83C30.0601 23.2 25.2101 30.55 16.3401 30.55C13.6201 30.55 11.0801 29.75 8.97009 28.37C9.35009 28.42 9.73009 28.44 10.1201 28.44C12.3801 28.44 14.4601 27.67 16.1101 26.38C14.0001 26.34 12.2201 24.95 11.6101 23.03C11.9101 23.09 12.2101 23.12 12.5201 23.12C12.9601 23.12 13.3901 23.06 13.7901 22.95C11.5801 22.5 9.92009 20.56 9.92009 18.22V18.16C10.5701 18.52 11.3101 18.74 12.1001 18.76C10.8001 17.9 9.95009 16.42 9.95009 14.75C9.95009 13.87 10.1901 13.04 10.6001 12.33C12.9801 15.25 16.5301 17.17 20.5401 17.37C20.4501 17.02 20.4101 16.65 20.4101 16.27C20.4101 13.61 22.5701 11.45 25.2301 11.45C26.6201 11.45 27.8701 12.03 28.7501 12.97C29.8501 12.75 30.8801 12.35 31.8101 11.8C31.4501 12.93 30.6901 13.87 29.6901 14.47C30.6701 14.35 31.6001 14.09 32.4601 13.71C31.8101 14.68 30.9901 15.53 30.0501 16.21C30.0601 16.41 30.0601 16.62 30.0601 16.83Z"
}, null, -1))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", {
    class: "icon-twitter",
    width: _ctx.px,
    height: _ctx.px,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _hoisted_3, 8, _hoisted_1))
}